import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SelectInput from 'react-select';
import './react-select.scss';

import ErrorMessage from 'Components/forms/helpers/ErrorMessage';

/**
 * From input component
 * 
 * @example ./Styleguide.md
 */
export default class Select extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        required: PropTypes.bool,
        className: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                value: PropTypes.string.isRequired,
                disabled: PropTypes.bool
            })
        ).isRequired,
        error: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string
        ]),
        helper: PropTypes.string,
        multi: PropTypes.bool,
        clearable: PropTypes.bool
    };
    static defaultProps = {
        onChange: (name, value) => { return false; },
        required: false,
        placeholder: '',
        className: '',
        value: '',
        error: false,
        helper: '',
        multi: false,
        clearable: true
    };

    onChange = value => {
        this.props.onChange(this.props.name, value);
    }

    render() {
        const { error, value, helper, options, multi, clearable } = this.props;

        const attrs = {
            name: this.props.name,
            required: this.props.required,
            className: this.props.className,
            placeholder: this.props.placeholder
        };

        return (
            <div className={`form-group select ${error ? "error" : ""} ${attrs.name} ${attrs.className}`}>
                <span className={`label-helper animated ${value ? 'fadeInUp' : ''}`}>{attrs.placeholder}</span>
                <SelectInput
                    name={attrs.name}
                    value={value}
                    options={options}
                    onChange={this.onChange}
                    multi={Boolean(multi)}
                    simpleValue={true}
                    clearable={clearable}
                />
                {helper ? <span className="helper">{helper}</span> : ''}
                {typeof error === "string" ? <ErrorMessage error={error} /> : ''}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/forms/Select/index.js